import { createFileRoute } from '@tanstack/react-router';
import { CreateVaultPage } from '../components/pages/CreateVaultPage/CreateVaultPage';

export const Route = createFileRoute('/account/vaults_/create')({
  component: CreateVaultPage,
});
